// extracted by mini-css-extract-plugin
module.exports = {"hypernativeIcon":"styles_hypernativeIcon__WL4o8","button":"styles_button__NMsmX"};